import { lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './index.css'
import './i18n'
import i18n from './i18n'
import App from './App.jsx'
import { initializeErrorLogger } from './lib/errorLogger'
import { initializeProductAnalytics } from './lib/productAnalytics'

const PublicBoardPage = lazy(() => import('./pages/PublicBoardPage.jsx'))

// Deploy-resilience: a tab running an OLD build 404s on hashed chunks a
// newer deploy removed. Vite fires `vite:preloadError` — reload ONCE per
// tab to pick up the fresh index.html (served no-store, so the reload is
// guaranteed fresh). STRICT one-shot: the flag is set once and NEVER
// cleared/time-windowed — if a reload doesn't fix it, we must NOT keep
// reloading (a time-based guard caused a periodic "refresh on timeout"
// loop in prod — 2026-05-19). Worst case after the single reload: a
// normal ErrorBoundary, not an infinite refresh.
window.addEventListener('vite:preloadError', (event) => {
  const KEY = 'kanbify_chunk_reloaded'
  if (sessionStorage.getItem(KEY)) return
  sessionStorage.setItem(KEY, '1')
  event.preventDefault?.()
  window.location.reload()
})

initializeErrorLogger()
initializeProductAnalytics()

createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <Routes>
      <Route
        path="/public/:token"
        element={
          <Suspense fallback={<div className="public-board-loading">{i18n.t('common.loading')}</div>}>
            <PublicBoardPage />
          </Suspense>
        }
      />
      <Route path="*" element={<App />} />
    </Routes>
  </BrowserRouter>,
)
